import {
  TopNSubgraphClientDetailsFragment,
  TopNSubgraphOperationDetailsFragment,
} from 'src/lib/graphqlTypes/types';

export const TRAFFIC_SOURCE_METRICS = {
  fetchCountPerMin: 'fetchCountPerMin',
  fetchErrorPercentage: 'fetchErrorPercentage',
  serviceTimeP95Ms: 'serviceTimeP95Ms',
} as const;

export type TrafficSourceSortMetric = keyof typeof TRAFFIC_SOURCE_METRICS;

export const TRAFFIC_SOURCE_METRIC_KEYS = Object.keys(
  TRAFFIC_SOURCE_METRICS,
) as TrafficSourceSortMetric[];

export type TrafficSourceMetricsData<T extends TrafficSourceSortMetric> = {
  [key in T]?: number | null;
};

export type OperationTrafficSourceData<T extends TrafficSourceSortMetric> =
  TopNSubgraphOperationDetailsFragment & TrafficSourceMetricsData<T>;

export type ClientTrafficSourceData<T extends TrafficSourceSortMetric> =
  TopNSubgraphClientDetailsFragment & TrafficSourceMetricsData<T>;

export const TRAFFIC_SOURCE_TYPES = {
  operations: 'operations',
  clients: 'clients',
} as const;

export type TrafficSourceType =
  (typeof TRAFFIC_SOURCE_TYPES)[keyof typeof TRAFFIC_SOURCE_TYPES];
